import n from "./index970.js";
function o(t) {
  var e = new t.constructor(t.byteLength);
  return new n(e).set(new n(t)), e;
}
export {
  o as default
};
